import { SourceType } from "../types/business"

export const SOURCE_TYPE_DISPLAY = {
  [SourceType.PROPRIETARY_THINKING]: "Proprietary", //No sourceName when sourceType is proprietary_thinking
  [SourceType.CORPORATE_ACCESS]: "Corpo. Access",
  [SourceType.SELL_SIDE]: "Sell Side",
}
